import { getDateInFormat } from "@domains/utils/reportDates";
export var CircularUpdate = function (data) {
    var result = {
        circular: [],
    };
    if (data && data.crclrs) {
        result.circular = mapCircularUpdates(data.crclrs);
    }
    return result;
};
var mapCircularUpdates = function (list) {
    return list.map(function (item) {
        return {
            circularID: item.circularID,
            circularNumber: item.circularNum,
            exchange: item.exchange,
            pdfPath: item.pdfPath,
            pdfReportName: item.pdfReportName,
            publishDate: getDateInFormat(item.publishDate, "MMM DD, YYYY"),
            title: item.title,
            extension: item.pdfPath ? item.pdfPath.split(".").pop() : "",
            isActive: item.isActive,
        };
    });
};
